import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Typography } from '@material-ui/core';
import Table from '../common/table/Table';
import TextFilter from '../common/table/filters/TextFilter';
import SelectFilter from '../common/table/filters/SelectFilter';
import { columns } from './Columns';
import { actions } from '../../actions/advertisementsActions';
import { statuses } from '../../models/advertisements/AdvertisementModel';

class AdvertisementsList extends React.Component {
  componentDidMount() {
    this.handleRefresh();
  }

  handleRefresh = () => {
    const { list, actions } = this.props;
    return actions.load(list.paging.pageNumber, list.paging.pageSize, list.sortedBy, list.filteredBy);
  }

  handlePageChange = page => {
    const { list, actions } = this.props;
    return actions.load(page, list.paging.pageSize, list.sortedBy, list.filteredBy);
  }

  handlePageSizeChange = size => {
    const { list, actions } = this.props;
    return actions.load(1, size, list.sortedBy, list.filteredBy);
  }

  handleSortChange = sort => {
    const { list, actions } = this.props;
    return actions.load(1, list.paging.pageSize, sort, list.filteredBy);
  }

  handleFiltersChange = filters => {
    const { list, actions } = this.props;
    return actions.load(1, list.paging.pageSize, list.sortedBy, filters.filter(f => f.value));
  }

  render() {
    const { list, error, busy, onEdit, onPublish, onDelete } = this.props;

    return (
      <div style={{ margin: 16 }}>
        <div className="flex-row flex-wrap" style={{ marginBottom: 16 }}>
          {list.filteredBy.map(filter =>
            filter.id === 'status' ? (
              <SelectFilter
                key={filter.id}
                readonly
                filter={filter}
                items={statuses}
                label="Status"
                onDelete={fn => this.handleFiltersChange(fn(list.filteredBy))}
              />
            ) : (
              <TextFilter
                key={filter.id}
                readonly
                filter={filter}
                label={filter.id === 'name' ? 'Nazwa' : 'Operator'}
                onDelete={fn => this.handleFiltersChange(fn(list.filteredBy))}
              />
            )
          )}
        </div>
        {error && (
          <div>
            <Typography color="error">
              Nie udało się pobrać reklam.
            </Typography>
            <Button onClick={this.handleRefresh}>Spróbuj ponownie</Button>
          </div>
        )}
        <Table
          columns={columns(onEdit, onPublish, onDelete, busy)}
          data={list.records}
          paging={list.paging}
          sortedBy={list.sortedBy}
          filteredBy={list.filteredBy}
          loading={list.loading}
          minRows={0}
          keyField="id"
          pageSize={list.paging.pageSize}
          pageSizeOptions={[20, 50, 100]}
          onPageChange={this.handlePageChange}
          onPageSizeChange={this.handlePageSizeChange}
          onSortedChange={this.handleSortChange}
          onFilteredChange={this.handleFiltersChange}
        />
      </div>
    );
  }
}

AdvertisementsList.propTypes = {
  actions: PropTypes.object.isRequired,
  list: PropTypes.object.isRequired,
  error: PropTypes.bool,
  busy: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    list: state.advertisements.pagedData,
    error: state.advertisements.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvertisementsList);
